import { createSelector } from 'reselect'
import { getInstancesDomainSelector } from 'modules/redux/selectors/domain'
import { PROMO_CODES_DOMAIN } from 'modules/promo-codes/constants'
import { isExpiredPromoCodeUtil } from 'models/daos/promo-code/utils'

/**
 * Returns the default promo code.
 * @returns {Function}
 */
function getPromoCodeSelector () {
  return createSelector(
    state => state && state.promoCodes,
    (promoCodes) => {
      let name = promoCodes.new
      if (name) {
        name = name.toLowerCase()
      }
      return promoCodes.data[name]
    }
  )
}

/**
 * Returns all the promo code that are not expired.
 * @returns {Function}
 */
function getAllNonExpiredPromoCodesSelector () {
  return createSelector(
    getInstancesDomainSelector(PROMO_CODES_DOMAIN),
    (promoCodes) => promoCodes.filter(p => !isExpiredPromoCodeUtil(p))
  )
}

export {
  getPromoCodeSelector,
  getAllNonExpiredPromoCodesSelector
}
